import type { AxiosRequestConfig } from 'axios'

/** 业务层请求配置（与 axios 一致，便于扩展） */
export type HttpRequestConfig<D = unknown> = AxiosRequestConfig<D>

export class HttpError extends Error {
  readonly status?: number
  readonly code?: string
  readonly body?: unknown

  constructor(
    message: string,
    init?: {
      status?: number
      code?: string
      body?: unknown
    },
  ) {
    super(message)
    this.name = 'HttpError'
    this.status = init?.status
    this.code = init?.code
    this.body = init?.body
  }
}
